export const STATUS = 0;
export const NOTE_NUM = 1;
export const NOTE_VELOCITY = 2;

export const NOTE_OFF = 0x80;
export const NOTE_ON = 0x90;

export const NOTE_MIDDLE_C = 60;
export const OCTAVE_OFFSET = -1